import { useTranslation } from "react-i18next"
import { SearchSeparator } from "@/components/ui/search"

type UnknownCareProviderItemProps = {
  hasSearchSeparator?: boolean
  onSelect: () => void
}

const UnknownCareProviderItem = ({ hasSearchSeparator, onSelect }: UnknownCareProviderItemProps) => {
  const { t } = useTranslation()

  return (
    <div className="bg-background sticky bottom-2 mx-2">
      {hasSearchSeparator && <SearchSeparator className="-mx-2.5 mt-2 mb-0.5" />}
      <div
        data-testid="unknown-care-provider-item"
        className="relative cursor-pointer items-center rounded-xl p-2 text-sm outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50"
        onClick={() => onSelect()}>
        <p data-testid="unknown-care-provider-title" className="text-primary">
          {t("admin.careProviders.unknownCareProvider.documentUnknownCareProvider")}
        </p>
        <p data-testid="unknown-care-provider-description" className="text-on-surface-subdued text-xs leading-4">
          {t("admin.careProviders.unknownCareProvider.description")}
        </p>
      </div>
    </div>
  )
}

export { UnknownCareProviderItem }
